// extracted by mini-css-extract-plugin
module.exports = {"component":"TypingIndicator_component_1SXdf","typingDot":"TypingIndicator_typingDot_2Iq2d","blink":"TypingIndicator_blink_36ZdQ","wave":"TypingIndicator_wave_3OmZY"};